// extracted by mini-css-extract-plugin
export var description = "ServiceCard-module--description--62bdc";
export var divider = "ServiceCard-module--divider--ed467";
export var firstTile = "ServiceCard-module--firstTile--3a538";
export var icons = "ServiceCard-module--icons--18325";
export var iconsWrapper = "ServiceCard-module--iconsWrapper--cd458";
export var link = "ServiceCard-module--link--32aa6";
export var root = "ServiceCard-module--root--03e3e";
export var size_lg = "ServiceCard-module--size_lg--18a8d";
export var size_md = "ServiceCard-module--size_md--7b663";
export var title = "ServiceCard-module--title--702aa";